export default __webpack_public_path__ + "static/media/About-what.6ca8dcbd.png";